import {
    PROFILE_UPDATE
} from "../../constants/action-types";

import initialState from "../initialState";

const profile = (state = initialState.profile, action) => {
    switch (action.type) {
        case PROFILE_UPDATE:
            return {
                ...state,
                user: action.payload.user,
                branch: action.payload.branch
            }

        default:
            return state;
    }
}

export default profile;


// WEBPACK FOOTER //
// ./src/store/reducers/profile.js